import TomSelect from "tom-select";
import { config } from "../TomSelect/config";
import { getArtistsByName } from "../helpers/ArtistApi";
import { getArtistsByIds } from "../helpers/ArtistApi";

export function initArtistMultiselect() {
    const artistSelects = document.querySelectorAll('select[data-select-entity="artist"]');

    artistSelects.forEach((select, index) => {
        const tomSelect = new TomSelect(select, {
            ...config, ...{
                load: function (query, callback) {
                    const self = this;

                    if( self.loading > 1 ){
                        callback();
                        return;
                    }

                    getArtistsByName(encodeURIComponent(query))
                        .then(res => res.data)
                        .then(json => {
                            callback(json);
                        }).catch(() => callback());
                }
            }
        });

        const defaultOptions = select.dataset.value ? JSON.parse(select.dataset.value) : [];

        if (defaultOptions.length) {
            getArtistsByIds(defaultOptions).then(res => {
                res.data.forEach((artist, index) => {
                    tomSelect.addOption(artist);
                    tomSelect.addItem(index);
                });

                tomSelect.setValue(defaultOptions);
            });
        }
    });
}
